module.exports = __webpack_public_path__ + "static/media/selectDone.852af764.png";